import { OrderProductConfirmLocationScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <OrderProductConfirmLocationScreen />;
}
